import { initStore, DEFAULT_PERMISSIONS } from '../../../common';
import { actions } from './actions';

export const createUserStore = (): void => {
	const initialState = {
		slice: 'USER_PAGE',
		username: '',
		usernameInvalid: false,
		email: '',
		emailInvalid: false,
		password: '',
		passwordFair: false,
		passwordStrong: false,
		partners: [],
		activePartners: [],
		image: null,
		imagePreview: null,
		languages: [],
		activeLanguage: [],
		dateTimes: [],
		activeDateTime: [],
		rolePermissions: [],
		roles: [],
		activeRoles: [],
		customRole: true,
		permissionGroups: [],
		activePermissions: [...DEFAULT_PERMISSIONS],
		openedGroups: [],
		users: [],
		activeUsers: [],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
